import { render, staticRenderFns } from "./consignee.vue?vue&type=template&id=33ca96ea&"
import script from "./consignee.vue?vue&type=script&lang=js&"
export * from "./consignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ca96ea')) {
      api.createRecord('33ca96ea', component.options)
    } else {
      api.reload('33ca96ea', component.options)
    }
    module.hot.accept("./consignee.vue?vue&type=template&id=33ca96ea&", function () {
      api.rerender('33ca96ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/basic/consignee.vue"
export default component.exports